import { render, staticRenderFns } from "./platform_teacherAuthority.vue?vue&type=template&id=5305a780&scoped=true&"
import script from "./platform_teacherAuthority.vue?vue&type=script&lang=js&"
export * from "./platform_teacherAuthority.vue?vue&type=script&lang=js&"
import style0 from "./platform_teacherAuthority.vue?vue&type=style&index=0&id=5305a780&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5305a780",
  null
  
)

export default component.exports